module.exports = __webpack_public_path__ + "media/src/images/icon__magazinFalsch1--dark-62c2b108de99094ab46ad4158fc80b12.svg";